module.exports = __webpack_public_path__ + "img/accelerator.7df39c99.svg";